/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div>
    <form
      id="my-groups-form"
      class="form-horizontal"
      :aria-label="(orgType == 'edu') ? 'Manage Classes' : 'Manage Groups'"
    >
      <div
        v-if="$store.getters.org && $store.getters.org.roles.indexOf('manager') !== -1"
        class="form-group row"
      >
        <div
          class="col-sm-12"
          :aria-label="(orgType == 'edu') ? 'Add Class Form' : 'Add Group Form'"
        >
          <label for="newGroup">
            <span v-if="orgType == 'edu'">
              Create a New Class
            </span>
            <span v-if="orgType != 'edu'">
              Create a New Group
            </span>
          </label><br>
          <input
            id="newGroup"
            v-model="newGroup"
            class="form-control"
            type="text"
            :placeholder="orgType == 'edu' ? 'enter the course/semester/section number' : 'enter the name'"
          >
          <button
            class="btn clear-btn"
            @click.self.prevent="addGroup()"
          >
            Save
          </button>
          <br><br>
        </div>
      </div>
      <div
        v-if="groups && groups.length"
        class="form-group row"
        :aria-label="(isEdu) ? 'View Class Details' : 'View Group Details'"
      >
        <div class="col-sm-4">
          <div class="form-group row">
            <div class="col-sm-2">
              <label
                for="groupSelector1"
                class="control-label"
              >
                <span v-if="isEdu">
                  Class
                </span>
                <span v-if="!isEdu">
                  Group
                </span>
              </label>
            </div>
            <div class="col-sm-10">
              <select
                id="groupSelector1"
                v-model="selectedGroup"
                class="form-control"
                @change="loadData"
              >
                <option
                  v-for="group in groups"
                  :value="group"
                >
                  {{ group.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-if="selectedGroup && selectedGroup.inviteCode"
          class="col-sm-4"
        >
          <div class="form-group row">
            <div class="col-sm-2">
              <label
                for="groupCode"
                class="control-label"
              >
                Invite Code
              </label>
            </div>
            <div class="col-sm-10">
              <input
                id="groupCode"
                class="form-control"
                type="text"
                :value="selectedGroup.inviteCode"
                readonly
                onclick="this.select();"
              >
            </div>
          </div>
        </div>
        <div
          v-if="selectedGroup && selectedGroup.inviteLink"
          class="col-sm-4"
        >
          <div class="form-group row">
            <div class="col-sm-2">
              <label
                for="groupLink"
                class="control-label"
              >
                Invite Link
              </label>
            </div>
            <div class="col-sm-10">
              <input
                id="groupLink"
                class="form-control"
                type="text"
                :value="selectedGroup.inviteLink"
                readonly
                onclick="this.select();"
              >
            </div>
          </div>
        </div>
      </div>
    </form>
    <div
      v-if="loading"
      class="text-center"
    >
      <h2>
        <svg
          class="icon-refresh rotate large-spinner"
        >
          <use xlink:href="/static/svg-symbols.svg#icon-refresh" />
        </svg>
        Loading...
      </h2>
    </div>
    <div v-if="!loading && speakers && speakers.length">
      <h2>
        <span v-if="orgType == 'edu'">
          Students
        </span>
        <span v-if="orgType != 'edu'">
          Speakers
        </span>
        <form
          v-if="showDownloadReport"
          style="display:inline;"
        >
          <button
            class="btn clear-btn"
            style="float:right;"
            @click.self.prevent="preDownloadReport()"
          >
            Download Report
          </button>
        </form>
      </h2>
      <table class="table table-bordered">
        <caption>
          {{ myClassesCaption }}
        </caption>
        <thead>
          <tr>
            <th
              width="40%"
              scope="col"
            >
              Name
            </th>
            <th
              width="20%"
              scope="col"
            >
              {{ myGroupsHeaders[0] }}
            </th>
            <th
              width="20%"
              scope="col"
            >
              {{ myGroupsHeaders[1] }}
            </th>
            <th
              width="20%"
              scope="col"
            >
              {{ myGroupsHeaders[2] }}
            </th>
          </tr>
        </thead>
        <tbody v-for="(speaker, index) in speakers">
          <tr :class="{ active: index % 2 == 0 }">
            <td
              scope="row"
            >
              <a
                v-if="speaker.recordings.length > 0"
                href="#"
                @click.prevent="expand(speaker)"
              >
                {{ speaker.name }}
              </a>
              <span v-if="speaker.recordings.length == 0">
                {{ speaker.name }}
              </span>
            </td>
            <td>{{ speaker.recordings.length }}</td>
            <td>{{ speaker.totalLength | time }}</td>
            <td>{{ speaker.lastRecordingDate | date }}</td>
          </tr>
          <tr
            v-if="speaker.recordings.length > 0"
            v-show="speaker.showRecordings"
            :class="{ active: index % 2 == 0 }"
          >
            <td
              colspan="4"
              class="well"
              style="padding-left:10%"
            >
              <table class="table table-condensed table-bordered">
                <caption>Recordings for {{ speaker.name }}</caption>
                <thead>
                  <tr>
                    <th
                      width="40%"
                      scope="col"
                    >
                      Title
                    </th>
                    <th
                      width="20%"
                      scope="col"
                    >
                      History
                    </th>
                    <th
                      width="20%"
                      scope="col"
                    >
                      Duration
                    </th>
                    <th
                      width="20%"
                      scope="col"
                    >
                      Vocal Delivery
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="recording in speaker.recordings">
                    <td scope="row">
                      <router-link
                        v-if="(currentUserId !== recording.userId) && recording.playbackUrl && showRecordingLinksForGroup[recording.groupId]"
                        :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
                      >
                        {{ recording.title }}
                      </router-link>
                      <router-link
                        v-if="(currentUserId === recording.userId) && recording.playbackUrl && showRecordingLinksForGroup[recording.groupId]"
                        :to="{ name: 'evaluate-recording', params: { recordingId: recording.recordingId } }"
                      >
                        {{ recording.title }}
                      </router-link>
                      <span v-if="!recording.playbackUrl || !showRecordingLinksForGroup[recording.groupId]">
                        {{ recording.title }}
                      </span>
                    </td>
                    <td>
                      Uploaded {{ recording.createdDate | date }}<br>
                      <div
                        v-if="isGroupManager && recording.submitted"
                        style="padding-top:0.5em"
                      >
                        Submitted on {{ recording.submissionDate | date }}
                        <br>
                      </div>
                      <div
                        v-if="isGroupManager && recording.feedbackRequested"
                        style="padding-top:0.5em"
                      >
                        Recording shared with entire {{ (orgType === 'edu') ? 'class' : 'group' }} on {{ recording.feedbackRequestedDate | date }}
                        <br>
                      </div>
                    </td>
                    <td>
                      {{ recording.duration | time }}
                    </td>
                    <td>
                      {{ (recording.results && recording.results.scores && recording.results.scores.overall) ? recording.results.scores.overall : 'N/A' }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else-if="groups && groups.length">
      {{ emptyGroup }}
    </div>
  </div>
</template>

<style lang="less" scoped>
  @media print {
    #my-groups-form, ul.nav-tabs {
      display: none;
    }
    div.tab-well {
      border: 0px;
    }
  }
  #newGroup {
    width: 255px;
    display: inline;
  }
  label[for=newGroup] {
    margin-right: 4px;
  }
</style>


<script>
import service from '../../services/groups';
import download from 'expose-loader?download!downloadjs/download.js'; // eslint-disable-line no-unused-vars
import BasePage from '../pages/BasePage';
import DownloadReport from '../specials/DownloadReport';
import ScorecardMixin from '../specials/ScorecardMixin';

export default {
  mixins: [BasePage, DownloadReport, ScorecardMixin],
  props: [ 'groups' ],
  data() {
    return {
      topLevelPage: false,
      selectedGroup: null,
      loading: false,
      feedbackLoaded: false,
      speakers: [],
      newGroup: '',
      showRecordingLinksForGroup: {},
    };
  },
  computed: {
    myClassesCaption: {
      cache: false,
      get() {
        if (this.loading || !this.selectedGroup) {
          return 'Loading...';
        }
        if (this.selectedGroup.roles.indexOf('manager') === -1) {
          return 'Click names below to view recordings your peers have shared with you';
        }

        if (this.selectedGroup.managerPrivacyLevel === 0) {
          if (this.isEdu) {
            return 'Sharing is disabled for this class';
          }
          return 'Sharing is disabled for this group';
        }
        if (this.selectedGroup.managerPrivacyLevel === 1) {
          if (this.isEdu) {
            return 'Class List - click a student\'s name to view their recordings';
          }
          return 'Group List - click a speaker\'s name to view their recordings';
        }
        if (this.selectedGroup.managerPrivacyLevel === 2) {
          return 'Click names below to view any recordings that have been shared with you';
        }
        if (this.selectedGroup.managerPrivacyLevel >= 3) {
          if (this.isEdu) {
            return 'Class List - note the count reflects only the number of recordings the student shared with you.';
          }
          return 'Group List - note the count reflects only the number of recordings the speaker shared with you';
        }

        // Nothing should ever use this value
        return 'Click names below to view any recordings that have been shared with you';
      }
    },
    emptyGroup: {
      cache: false,
      get() {
        if (this.loading || !this.selectedGroup) {
          return 'Loading...';
        }
        const students = (this.isEdu) ? 'students' : 'speakers';
        const _class = (this.isEdu) ? 'class' : 'group';

        // If they're not a manager in the group and sharing is disabled, show a special msg
        if (this.selectedGroup.roles.indexOf('manager') === -1 &&
          this.selectedGroup.speakerPrivacyLevel === 0 ||
          this.selectedGroup.speakerPrivacyLevel >= 4) {
          return `Peer sharing is not enabled on this ${_class}.`;
        }

        return `There are currently no other ${students} in this ${_class}.`;
      }
    },
    showDownloadReport() {
      const org = this.$store.getters.org;
      const downloadReportEnabled = (org && typeof org.settings !== 'undefined' && org.settings.Download_Report_Button);
      const isGroupManager = (this.selectedGroup && this.selectedGroup.roles && this.selectedGroup.roles.indexOf('manager') !== -1);

      return (isGroupManager && downloadReportEnabled);
    },
    currentUserId() {
      return this.$store.getters.user.userId;
    },
  },
  created() {
    // Hack to try and fix users who are not seeing their classes load
    if (!this.groups.length && typeof window.__retriedGroupsLookup === 'undefined') {
      this.$store.dispatch('listGroups')
        .then(() => {
          this.groups = this.activeGroups;
          this.selectedGroup = this.groups[0];
          this.loadData();
        });
      window.__retriedGroupsLookup = true;

      // Do not log an error for orgLevel managers because they might actually not
      // yet belong to a class
      if (!this.isOrgLevelManager) {
        window.Raven.captureMessage('Retried listGroups on Manage page');
      }
      return;
    }

    // this._.find is needed to discard __manageGroupsState when someone logs in as a user in a different org
    if (window.__manageGroupsState && this._.find(this.groups, {groupId: window.__manageGroupsState.groupId})) {
      // Reloading cached version
      this.selectedGroup = window.__manageGroupsState;
      this.loadData();
    } else {
      // Initial page load
      if (!this.selectedGroup) {
        this.selectedGroup = this.groups[0];
        this.loadData();
      }
    }

    // Decide when to hyperlink recordings
    this.activeGroups.forEach((group) => {
      this.showRecordingLinksForGroup[group.groupId] = !!(group.speakerPrivacyLevel > 0);
    });
  },
  deactivated() {
    window.__manageGroupsState = this.selectedGroup;
  },
  methods: {
    addGroup() {
      const showNewGroup = () => {
        this.loading = true;
        this.$store.dispatch('listGroups').then((groups) => {
          this.selectedGroup = this._.find(groups, (obj) => obj.name == this.newGroup);
          this.speakers = [];
          this.newGroup = '';
          this.loading = false;
        });
      };

      if (this.newGroup === '') {
        document.getElementById('newGroup').focus();
      } else {
        this.$store.dispatch('addGroup', {
          name: this.newGroup,
          orgName: this.$store.getters.org.name
        })
          .then(() => window.setTimeout(showNewGroup, 1000))
          .catch(() => {
            this.loading = false;
            alert('The group could not be saved. Most likely, the name you entered is already used elsewhere. ' +
              'Please change the name to be unique.');
          });
      }
    },
    loadData() {
      if (!this.selectedGroup) {
        // Do not log an error for orgLevel managers
        if (!this.isOrgLevelManager) {
          window.Raven.captureMessage('Could not determine selectedGroup on Manage page');
        }
        return;
      }
      const groupId = this.selectedGroup.groupId;
      this.loading = true;
      this.speakers = [];
      this.$store.dispatch('listGroupMembers')
        .then(() => {
          // We need this._.cloneDeep to avoid vuex mutation warnings
          const members = this._.cloneDeep(this.$store.getters.groupMembers[groupId]);
          const speakers = this._.sortBy(this._.filter(members, member => {
            return (this._.includes(member.roles, 'speaker') && member.userId !== this.currentUserId);
          }), speaker => speaker.lastName.toUpperCase(), speaker => speaker.firstName.toUpperCase());

          return service.listRecordings(groupId)
            .then(recordings => {
              const groupedRecordings = this._.groupBy(recordings, recording => recording.userId);

              this._.forEach(speakers, speaker => {
                const recordings = groupedRecordings[speaker.userId.toString()] || [];
                speaker.recordings = this._.sortBy(recordings, r => -new Date(r.createdDate).getTime());
                if (recordings.length) {
                  speaker.totalLength = this._.sum(this._.map(recordings, r => r.duration || 0));
                  speaker.lastRecordingDate = this._.max(this._.map(recordings, r => new Date(r.createdDate).getTime()));
                } else {
                  speaker.totalLength = 0;
                }
                speaker.showRecordings = false;
              });

              this.speakers = speakers;
              this.loading = false;

              // Show the last viewed speaker
              this.speakers.forEach((speaker) => {
                if (window.__activeSpeaker && speaker.userId === window.__activeSpeaker.userId) {
                  this.expand(speaker);
                }
              });
            });
        });
    },
    expand(speaker) {
      speaker.showRecordings = !speaker.showRecordings;
      if (speaker.showRecordings) {
        window.__activeSpeaker = speaker;
      }
    }
  }
};
</script>
